import Marquee from "react-fast-marquee";
import { Reveal } from "@/components/Reveal";
import { Counter } from "@/components/Counter";
import { SectionHeading } from "@/components/SectionHeading";
import { fadeUp } from "@/lib/motion";
import { ACHIEVEMENTS, CLIENT_LOGOS } from "@/data/content";

const AchievementsSection = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-[#F8FAFC] overflow-hidden" id="achievements" data-testid="achievements-section">
      <div className="max-w-[1320px] mx-auto px-5 sm:px-8">
        <SectionHeading
          align="center"
          overline="Achievements"
          title="A Track Record of Certifications Delivered"
          description="Numbers that reflect real programs taken from application to approval."
          className="mb-16"
        />

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-5 mb-20">
          {ACHIEVEMENTS.map((a, i) => (
            <Reveal key={a.label} variants={fadeUp} custom={i % 5}>
              <div className="h-full rounded-2xl bg-white border border-slate-200 p-7 text-center hover:shadow-lg hover:shadow-slate-900/5 transition-shadow">
                <div className="font-display font-bold text-4xl sm:text-5xl text-[#1E40AF]">
                  <Counter value={a.value} suffix={a.suffix} />
                </div>
                <p className="mt-3 text-sm text-slate-500 leading-snug">{a.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Client logo carousel */}
      <Reveal className="max-w-[1320px] mx-auto px-5 sm:px-8 mb-8">
        <p className="text-center text-xs font-semibold tracking-[0.25em] uppercase text-slate-400">
          Trusted by manufacturers and suppliers
        </p>
      </Reveal>
      <div className="relative" data-testid="client-logo-carousel">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-[#F8FAFC] to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-[#F8FAFC] to-transparent" />
        <Marquee speed={40} gradient={false} pauseOnHover>
          {CLIENT_LOGOS.map((logo) => (
            <div key={logo} className="mx-5 flex items-center justify-center h-16 px-8 rounded-xl bg-white border border-slate-200">
              <span className="font-display font-semibold text-lg text-slate-400 whitespace-nowrap">{logo}</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default AchievementsSection;
